// link forms
export const LinkWide = 'LinkWide'
export const LinkWrapper = 'LinkWrapper'
export type LinkKind = typeof LinkWide | typeof LinkWrapper
